import '../../blocks/installer-form/installer-form.scss';
import InstallerResource from '../../blocks/resource/resource';
import WizardInfo from '../../blocks/wizard-info/wizard-info';
import LoaderNg from '@jetbrains/ring-ui/components/loader-ng/loader-ng';

const PING_INTERVAL = 5 * 1000;
const PING_TIMEOUT = 2 * 1000;
const installationNameMarker = '${installationName}';

export default angular.module('installer.installation-progress', [LoaderNg, InstallerResource.name, WizardInfo.name]).
  controller('InstallationProgressController', function controller($log, $window, $rootScope, $routeParams, $http, $q, installerResource, wizardInfo, i18n) {
    const ctrl = this;
    const serviceUrl = $routeParams.url;
    const isUpgrade = $routeParams.action === 'upgrade';
    const warningLocalizedText = i18n('Installation of ${installationName} is still in progress.');

    const warningText = warningLocalizedText.replace(installationNameMarker, wizardInfo.productPresentationName);

    $window.onbeforeunload = () => warningText;

    /**
     * Disable going back
     */
    // eslint-disable-next-line angular/on-watch
    $rootScope.$on('$locationChangeStart', event => {
      event.preventDefault();
    });

    /**
     * Waits while wizard turning off
     * @returns {promise}
     */
    ctrl.waitForWizardTurnOff = function fn() {
      const defer = $q.defer();

      const pingWizardOffFn = () => {
        installerResource.waitPing.get().$promise.then(function wizardStillWorks() {
          setTimeout(pingWizardOffFn, PING_INTERVAL);
        }, function onWizardUnavailable(err) {
          $log.debug('Wizard is turned off');
          defer.resolve(err);
        });
      };
      pingWizardOffFn();

      return defer.promise;
    };

    ctrl.waitForFinish = () => {

      const pingServiceFn = () => {
        $http.get(serviceUrl, {timeout: PING_TIMEOUT, __wizardDoNotInterceptOnError: true}).
          then(function onSuccess() {
            $window.onbeforeunload = null;
            $window.location.href = serviceUrl;
          }, function onError() {
            $log.debug(`Service ${serviceUrl} is not responding, retrying...`);
            setTimeout(pingServiceFn, PING_INTERVAL);
          });
      };

      pingServiceFn();

    };

    ctrl.isUpgrade = () => isUpgrade;

    ctrl.waitForWizardTurnOff().then(ctrl.waitForFinish);

  }).
  config($routeProvider => {
    $routeProvider.
      when('/wait', {
        template: require('./installation-progress.html'),
        controller: 'InstallationProgressController as ctrl',
        reloadOnSearch: false
      });
  });



// WEBPACK FOOTER //
// ./src/pages/installation-progress/installation-progress.js